// 佐川 便種マッピング（Issue #32）。
//   便種コード → 計上区分（宅急便単価 / ネコポス単価 / その他 / 対象外）。
//   本城さんが設定画面で編集できる。新便種（例: ジャスト便）が来たら割り当てる。
//
// デフォルトは 2026-06-08 本城さん確定の現行マッピングを完全再現する（rules 省略時の既定挙動）。

import type { SagawaBenkindRule, SagawaBenkindCategory } from "../../types";

export const DEFAULT_SAGAWA_BENKIND_RULES: SagawaBenkindRule[] = [
  { code: "001", name: "一般宅配", category: "takkyu" },
  { code: "006", name: "代引", category: "takkyu" },
  { code: "007", name: "クール便", category: "takkyu" },
  { code: "008", name: "商業貨物", category: "takkyu" },
  { code: "009", name: "着払", category: "takkyu" },
  { code: "061", name: "一般(集荷)", category: "takkyu" },
  { code: "004", name: "メール便", category: "nekopos" },
  { code: "104", name: "荷捌代金(月額)", category: "ignore" },
  { code: "105", name: "車両維持(月額)", category: "ignore" },
];

// 便種コードの計上区分を返す。ルールが無ければ null（＝未知。取込時に #7 検証で弾く）。
export function classifySagawaCode(
  code: string,
  rules: SagawaBenkindRule[] = DEFAULT_SAGAWA_BENKIND_RULES
): SagawaBenkindCategory | null {
  const r = rules.find((x) => x.code === code);
  return r ? r.category : null;
}
